<template>
<main>
    <div class="container margin_30">
        <div class="page_header">
            <div class="breadcrumbs">
                <ul>
                    <li>Privacy Policy</li>
                </ul>
            </div>
            <h2><strong>Privacy Policy</strong></h2>
        </div>
        
        <div class=" "> 
            <div class="row justify-content-center">
                <div class="col-7">
                    <div id="post-privacy" class="post-privacy page type-page status-publish hentry">
                        <div class="nt-anarkali-content nt-clearfix content-container">
                            <p>Last updated: April 05, 2024</p>
                            <p>This Privacy Policy describes how <strong>Edutech Institute</strong> (“Company”, “We”, “Our”, or “Us”) collects, uses, and protects Your personal information when You access and use our platform, related applications, and services.</p>
                            <p>By using our platform, You agree to the practices described in this Privacy Policy. If You do not agree, please discontinue use of our services.</p>

                            <h2>Interpretation and Definitions</h2>
                            <h3>Definitions</h3>
                            <ul>
                                <li><strong>Account</strong> – A unique profile created for You to access courses and platform features.</li>
                                <li><strong>Company</strong> – Edutech Institute.</li>
                                <li><strong>Cookies</strong> – Small data files stored on Your device to improve the platform experience.</li>
                                <li><strong>Device</strong> – Any device such as a computer, tablet, or smartphone used to access the platform.</li>
                                <li><strong>Instructor</strong> – Authorized educators providing learning content on the platform.</li>
                                <li><strong>Student / Learner</strong> – Any individual enrolled in courses on the platform.</li>
                                <li><strong>Personal Data</strong> – Any data that identifies You as an individual (e.g., name, email, phone).</li>
                                <li><strong>Service</strong> – Edutech Institute platform, applications, and related services.</li>
                                <li><strong>Usage Data</strong> – Automatically collected information such as login time, course progress, IP address, browser type, etc.</li>
                            </ul>

                            <h2>Collecting and Using Your Personal Data</h2>
                            <h3>Types of Data Collected</h3>
                            <h4>Personal Data</h4>
                            <p>We may collect the following personal information when You register or use the platform:</p>
                            <ul>
                                <li>Name and contact details (email, phone)</li>
                                <li>Login credentials and authentication data</li>
                                <li>Billing and payment details (if You purchase a course/subscription)</li>
                                <li>Learning progress, quiz results, and certifications earned</li>
                                <li>Usage Data such as login frequency, course completion rates</li>
                            </ul>

                            <h4>Usage Data</h4>
                            <p>We collect data automatically, including:</p>
                            <ul>
                                <li>Your IP address and browser type</li>
                                <li>Course access time and duration</li>
                                <li>Device information</li>
                                <li>Interactions with content (videos, quizzes, assignments)</li>
                            </ul>

                            <h4>Tracking Technologies</h4>
                            <p>We use cookies and similar tools to:</p>
                            <ul>
                                <li>Maintain session logins</li>
                                <li>Personalize course recommendations</li>
                                <li>Track learning progress</li>
                                <li>Improve system performance</li>
                            </ul>

                            <h3>Use of Your Personal Data</h3>
                            <p>We use the collected information to:</p>
                            <ul>
                                <li>Provide and manage platform access</li>
                                <li>Track Your course progress and generate certificates</li>
                                <li>Communicate updates, course notifications, or support messages</li>
                                <li>Process payments for paid courses/subscriptions</li>
                                <li>Improve content quality and platform performance</li>
                                <li>Ensure academic integrity and prevent misuse</li>
                            </ul>

                            <h3>Sharing Your Personal Data</h3>
                            <ul>
                                <li><strong>With Instructors:</strong> Your progress and submissions may be visible to assigned educators.</li>
                                <li><strong>With Service Providers:</strong> For hosting, analytics, payments, and communications.</li>
                                <li><strong>With Academic Partners:</strong> If You are enrolled via an institution that uses our platform.</li>
                                <li><strong>With Legal Authorities:</strong> If required by applicable laws or regulations.</li>
                                <li><strong>With Your Consent:</strong> We may share additional information with third parties only with Your explicit approval.</li>
                            </ul>

                            <h3>Data Retention</h3>
                            <p>We retain Your data as long as Your account is active or as required by law. Learning history and certificates may be retained to verify academic achievements.</p>

                            <h3>Data Security</h3>
                            <p>We implement industry-standard measures to protect Your data. However, no method of transmission or storage is 100% secure. We cannot guarantee absolute security.</p>

                            <h2>Children's Privacy</h2>
                            <p>Our platform is not intended for children under the age of 13 (or the minimum age in Your country). We do not knowingly collect data from minors without parental consent.</p>

                            <h2>Links to Third-Party Sites</h2>
                            <p>The platform may contain links to third-party educational resources. We are not responsible for their privacy policies or practices.</p>

                            <h2>Changes to this Privacy Policy</h2>
                            <p>We may update this Privacy Policy from time to time. Changes will be posted here with an updated “Last Updated” date. Continued use of the platform means You accept those changes.</p>

                            <h2>Contact Us</h2>
                            <p>If You have questions about this Privacy Policy, please contact us:</p>
                            <ul>
                                <li>By email: support@dktechs.in</li>
                            </ul>

                            <router-link to="/" class="btn btn-primary mt-1 mb-1">
                                Go to Home
                                </router-link>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
</template>
